import dayjs from "dayjs";
import React, { PureComponent } from "react";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Line,
  ComposedChart,
  Bar,
  LineChart,
  ReferenceLine,
  Scatter,
  Cell,
} from "recharts";
import nodata from '../../src/assets/images/no-data.png'

export default class Example extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() { }

  render() {


const graphData = this.props.fuelGraphData || {};
const refillData = this.props.fuelRefillData || [];

// Fuel readings
const fuelPoints = Object.values(graphData)
  .flat()
  .map(item => ({
    timestamp: item.timestamp,
    name: dayjs(item.timestamp).format("HH:mm"),
    fullName: dayjs(item.timestamp).format("DD-MM HH:mm"), // date+time label
    fuelLine: Number(item.fuel || 0),
    refillfuel: 0,
  }));

// Keep first, last, and every 30th fuel point
const reducedFuelPoints = fuelPoints.filter((item, index, arr) => {
  if (index === 0 || index === arr.length - 1) return true;
  return index % 30 === 0;
});

// Map for quick lookup
const mergedMap = {};

reducedFuelPoints.forEach(item => {
  const key = dayjs(item.timestamp).format("YYYY-MM-DD HH:mm");
  mergedMap[key] = {
    ...item,
    refillfuel: 0,
  };
});

refillData.forEach(item => {
  const key = dayjs(item.timestamp).format("YYYY-MM-DD HH:mm");
  if (mergedMap[key]) {
    mergedMap[key].refillfuel = Number(item.refillfuel || 0);
  } else {
    mergedMap[key] = {
      timestamp: item.timestamp,
      name: dayjs(item.timestamp).format("HH:mm"),
      fullName: dayjs(item.timestamp).format("DD-MM HH:mm"),
      fuelLine: null,
      refillfuel: Number(item.refillfuel || 0),
    };
  }
});

const mergedData = Object.values(mergedMap).sort(
  (a, b) => dayjs(a.timestamp).valueOf() - dayjs(b.timestamp).valueOf()
);

// Check if data spans multiple dates
const uniqueDates = [...new Set(mergedData.map(item => dayjs(item.timestamp).format("YYYY-MM-DD")))];
const isMultiDay = uniqueDates.length > 1;

return mergedData.length > 0 ? (
  <ResponsiveContainer width="100%" height={250}>
    <ComposedChart data={mergedData}>
      <CartesianGrid stroke="#f5f5f5" />

      <XAxis
        dataKey={isMultiDay ? "fullName" : "name"}  // DD-MM HH:mm for multi-day, HH:mm for single day
        interval="preserveStartEnd"
        tick={{ fontSize: 11 }}
      />

      <YAxis />

      <Tooltip
        labelFormatter={(label, payload) => {
          if (payload && payload.length > 0) {
            const ts = payload[0]?.payload?.timestamp;
            return ts
              ? `${dayjs(ts).format(isMultiDay ? "DD-MM-YYYY HH:mm:ss" : "HH:mm:ss")}`
              : label;
          }
          return label;
        }}
        formatter={(value, name) => [
          name === "Fuel Level"
            ? `${value} L`
            : value > 0 ? `${value} L` : null,
          name,
        ]}
      />

      <Bar
        dataKey="refillfuel"
        fill="green"
        barSize={100}
        name="Refill Fuel"
      />

      <Line
        type="monotone"
        dataKey="fuelLine"
        stroke="#8884d8"
        strokeWidth={2}
        dot={false}
        connectNulls
        name="Fuel Level"
      />
    </ComposedChart>
  </ResponsiveContainer>
) : (
  <div
    style={{
      height: 200,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
    }}
  >
    <img src={nodata} alt="No Data" style={{ width: 120, opacity: 0.7 }} />
    <p>No graph data available</p>
  </div>
);
    
  }
}
